// Formats the true, backend-stored sno into a sequential display label
// (1, 2, 2A, 3, ...) without altering the underlying true sno used for
// submissions and comparisons.
export function formatDisplaySno2(products = []) {
  let currentBase = 0;
  let alternateCount = 0;

  return products.map((item) => {
    const isAlternate = item?.isAlternate ?? item?.alternate ?? false;
    if (isAlternate) {
      alternateCount++;
      // 64 + 1 = 65 ('A'), 64 + 2 = 66 ('B'), etc.
      return { ...item, display_sno: `${currentBase}${String.fromCharCode(64 + alternateCount)}` };
    } else {
      currentBase++;
      alternateCount = 0;
      return { ...item, display_sno: String(currentBase) };
    }
  });
}

export function formatDisplaySno(products = []) {
  let altCounts = {};

  return (products || []).map((item) => {
    let rawSno = String(item?.sno || item?.sNo || item?.s_no || "");
    let match = rawSno.match(/^(\d+)/);

    if (!match) return item;

    let baseNum = match[1];
    const isAlternate = item?.isAlternate ?? item?.alternate ?? false;

    if (isAlternate) {
      let count = (altCounts[baseNum] || 0) + 1;
      altCounts[baseNum] = count;
      return { ...item, display_sno: `${baseNum}${String.fromCharCode(64 + count)}` };
    } else {
      altCounts[baseNum] = 0;
      return { ...item, display_sno: baseNum };
    }
  });
}


